// src/components/Terms.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

const Term = ({ number, text }) => (
  <div
    style={{
      display: "flex",
      gap: "16px",
      marginBottom: "20px",
      alignItems: "flex-start",
    }}
  >
    <div
      style={{
        width: "28px",
        height: "28px",
        borderRadius: "50%",
        background: "rgba(64,190,180,0.1)",
        border: "1px solid rgba(64,190,180,0.25)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "12px",
        fontWeight: 700,
        color: "#40BEB4",
        flexShrink: 0,
        marginTop: "1px",
      }}
    >
      {number}
    </div>
    <p style={{ color: "rgba(255,255,255,0.65)", fontSize: "14px", lineHeight: "1.8", margin: 0 }}>
      {text}
    </p>
  </div>
);

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        background: "linear-gradient(160deg, #071520 0%, #0a1e2e 35%, #071018 100%)",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "48px 24px 72px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Grid background */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `
            linear-gradient(rgba(64,190,180,0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(64,190,180,0.03) 1px, transparent 1px)
          `,
          backgroundSize: "48px 48px",
          pointerEvents: "none",
        }}
      />

      {/* Back button */}
      <div style={{ width: "100%", maxWidth: "720px", marginBottom: "32px", position: "relative", zIndex: 1 }}>
        <button
          onClick={() => navigate(-1)}
          style={{
            background: "rgba(64,190,180,0.08)",
            border: "1px solid rgba(64,190,180,0.2)",
            color: "#40BEB4",
            padding: "8px 20px",
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "13px",
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}
        >
          ← Back
        </button>
      </div>

      {/* Card */}
      <div
        style={{
          maxWidth: "720px",
          width: "100%",
          background: "rgba(10, 25, 40, 0.92)",
          backdropFilter: "blur(12px)",
          border: "1px solid rgba(64,190,180,0.2)",
          borderRadius: "24px",
          padding: "48px",
          position: "relative",
          zIndex: 1,
          boxShadow: `
            0 0 0 1px rgba(255,255,255,0.03) inset,
            0 24px 64px rgba(0,0,0,0.6),
            0 0 48px rgba(64,190,180,0.07)
          `,
        }}
      >
        {/* Header */}
        <div style={{ marginBottom: "40px", textAlign: "center" }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "48px",
              height: "48px",
              borderRadius: "12px",
              background: "rgba(64,190,180,0.1)",
              border: "1px solid rgba(64,190,180,0.25)",
              marginBottom: "16px",
              fontSize: "22px",
            }}
          >
            📋
          </div>
          <h1
            style={{
              fontSize: "28px",
              fontWeight: 700,
              color: "#40BEB4",
              marginBottom: "8px",
              letterSpacing: "-0.3px",
            }}
          >
            Terms &amp; Conditions
          </h1>
          <p style={{ color: "rgba(255,255,255,0.35)", fontSize: "13px" }}>
            Please read these terms carefully before using the platform.
          </p>
        </div>

        {/* Divider */}
        <div
          style={{
            height: "1px",
            background: "linear-gradient(90deg, transparent, rgba(64,190,180,0.25), transparent)",
            marginBottom: "36px",
          }}
        />

        <Term
          number="1"
          text="By using this platform, you agree to provide accurate and truthful information for KYC verification."
        />
        <Term
          number="2"
          text="This service is intended only for identity verification purposes and must not be used for any other activity."
        />
        <Term
          number="3"
          text="We are not responsible for incorrect, false, or incomplete details submitted by users. The responsibility lies solely with the applicant."
        />
        <Term
          number="4"
          text="Usage of this platform implies your explicit consent to process Aadhaar data via DigiLocker as per applicable laws."
        />
        <Term
          number="5"
          text="We reserve the right to reject or cancel a KYC application if discrepancies or fraudulent information are detected."
        />
        <Term
          number="6"
          text="This platform and its services are subject to applicable Indian laws and regulations governing data privacy and identity verification."
        />

        {/* Notice box */}
        <div
          style={{
            marginTop: "8px",
            padding: "16px 20px",
            borderRadius: "12px",
            background: "rgba(64,190,180,0.05)",
            border: "1px solid rgba(64,190,180,0.15)",
          }}
        >
          <p style={{ color: "rgba(255,255,255,0.45)", fontSize: "13px", margin: 0, lineHeight: "1.7" }}>
            By proceeding with the Video KYC process, you confirm that you have read, understood,
            and agreed to these Terms &amp; Conditions.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
